const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-video",
  "data-name": "Icon feather-video",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2430",
  "data-name": "Path 2430",
  d: "M31.3,10.5,24,15.711l7.3,5.211Z",
  transform: "translate(-8.366 -8.415)",
  fill: "none",
  stroke: "#008941",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2431",
  "data-name": "Path 2431",
  d: "M3.585,7.5H15.05a2.085,2.085,0,0,1,2.085,2.085V20.007a2.085,2.085,0,0,1-2.085,2.085H3.585A2.085,2.085,0,0,1,1.5,20.007V9.585A2.085,2.085,0,0,1,3.585,7.5Z",
  transform: "translate(-1.5 -7.5)",
  fill: "none",
  stroke: "#008941",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));
function SvgIconfeatherVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.93,
    height: 16.592,
    viewBox: "0 0 24.93 16.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfeatherVideo);
export default __webpack_public_path__ + "static/media/Icon feather-video.df1759c0.svg";
export { ForwardRef as ReactComponent };